import { Component, OnDestroy } from '@angular/core';

import { Notification } from '@ridango/core';

import { HelperService } from '../../services/helper.service';

@Component({
    selector: 'gl-base-page',
    templateUrl: './base-page.component.html'
})
export class BasePageComponent implements OnDestroy {
    private notificationQueue: Notification[] = [];
    constructor(private helper: HelperService) {}

    ngOnDestroy() {
        this.helper.displayNotifications();
    }

    addNotificationToQueue(notification: Notification) {
        this.helper.addNotificationToQueue(notification);
    }
}
